// extracted by mini-css-extract-plugin
export default {"layout":"Social_layout__EJzU6","navItem":"Social_navItem__XCdIg","navLink":"Social_navLink__8ssBP"};